export default "__VITE_ASSET__BjY4vapL__"